<template>
  <a
    :class="options.class"
    @click="$parent.$parent.$parent.reloadFunction(data.id)"
    href="#"
    ><i class="ag-icon ag-icon_reload"></i
  ></a>
</template>

<script>
export default {
  name: "tableReloadComponent",
  props: {
    data: {
      type: Array,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
  },
};
</script>

<style scoped></style>
